<template>
  <div class="gallery" ref="gallery">
    <!-- Replace these placeholder images with URLs of your club photos -->
    <img src="../gallery/1.jpg" alt="Image 1">
    <img src="../gallery/8.jpg" alt="Image 1">
    <img src="../gallery/9.jpg" alt="Image 1">
    <img src="../gallery/2.jpg" alt="Image 1">
    <img src="../gallery/3.jpg" alt="Image 1">
    <img src="../gallery/4.jpg" alt="Image 1">
    <img src="../gallery/5.jpg" alt="Image 1">
    <img src="../gallery/6.jpg" alt="Image 1">
    <img src="../gallery/7.jpg" alt="Image 1">
    <!-- Add more images as needed -->
  </div>
</template>

<script>
export default {
  name: 'GalleryPage',
  methods: {
    handleScroll() {
      const gallery = this.$refs.gallery;
      const scrollPosition = window.scrollY;
      const parallaxValue = scrollPosition * 0.3;

      gallery.style.transform = `translateY(${parallaxValue}px)`;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
/* Add your styling here */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 30px;
  transition: transform 0.5s ease-in-out;
}

.gallery img {
  width: 600px;
  height: 500px;
  object-fit: cover;
  margin: 20px;
  cursor: pointer;
  transition: transform 0.3s, margin 0.3s, box-shadow 0.3s;
  transform-style: preserve-3d;
  border-radius: 10px;
  border: 2px solid #ddd;
}

.gallery img:hover {
  transform: scale(1.1) rotateY(10deg);
  margin: 10px;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.5);
}
</style>
